import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { createApp } from "vue";
import './element.scss';
import App from "./App.vue";
import router from "./router";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import i18n from './i18n'
import packageJson from "../package.json"

// The agent loader code executes immediately on instantiation. 
const nrba = new BrowserAgent({
  init: { distributed_tracing: { enabled: true }, performance: { capture_measures: true }, browser_consent_mode: { enabled: false }, privacy: { cookies_enabled: true }, ajax: { deny_list: ["bam.nr-data.net"] } },
  loader_config: { accountID: "459743", trustKey: "459743", agentID: "718423836", licenseKey: "ece789de19", applicationID: "718423836" },
  info: {beacon:"bam.nr-data.net",errorBeacon:"bam.nr-data.net",licenseKey:"ece789de19",applicationID:"718423836",sa:1}
})
nrba.setApplicationVersion(packageJson.version);

let host = location.pathname.split('/')[1];
if(!host)
  host = "ecogy";

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app
.use(i18n)
.use(router)
.mount("#app"); 
